var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col announce-sec" }),
      _vm._v(" "),
      _c("div", { staticClass: "col content" }, [
        _c("div", { staticClass: "login-form-sec" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "login-content" }, [
            _vm.step === 1
              ? _c("form", [
                  !_vm.passErrValid && _vm.display.login_error
                    ? _c(
                        "div",
                        {
                          staticClass: "alert alert-danger",
                          attrs: { role: "alert" }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.display.login_error) + "\n            "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.passErrValid && _vm.display.login_error
                    ? _c(
                        "div",
                        {
                          staticClass: "alert alert-success",
                          attrs: { role: "alert" }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.display.login_error) + "\n            "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: { "has-error": _vm.errors.has("email") }
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "control-label visible-ie8 visible-ie9"
                        },
                        [_vm._v("Username")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-icon" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.username,
                              expression: "form.username"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required|email",
                              expression: "'required|email'"
                            }
                          ],
                          ref: "email",
                          class:
                            "form-control" +
                            (_vm.getError("email") ? " txterror" : ""),
                          attrs: {
                            type: "email",
                            name: "email",
                            placeholder: "Email"
                          },
                          domProps: { value: _vm.form.username },
                          on: {
                            keypress: function($event) {
                              return _vm.entSub(_vm.form)
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.form,
                                "username",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _vm.errors.has("email") && _vm.form.username
                        ? _c("span", { staticClass: "error" }, [
                            _vm._v("Please enter a valid email address.")
                          ])
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: { "has-error": _vm.errors.has("password") }
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "control-label visible-ie8 visible-ie9"
                        },
                        [_vm._v("Password")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-icon" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.password,
                              expression: "form.password"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          ref: "password",
                          class:
                            "form-control" +
                            (_vm.getError("password") ? " txterror" : ""),
                          attrs: {
                            type: "password",
                            name: "password",
                            placeholder: "Password"
                          },
                          domProps: { value: _vm.form.password },
                          on: {
                            keypress: function($event) {
                              return _vm.entSub(_vm.form)
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.form,
                                "password",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-actions" }, [
                    _c(
                      "button",
                      {
                        staticClass: "b-btn red-btn",
                        attrs: {
                          type: "button",
                          disabled:
                            _vm.errors.count() > 0 || _vm.waiting == true
                        },
                        on: { click: _vm.loginAction }
                      },
                      [_vm._v("Login\n              ")]
                    )
                  ]),
                  _vm._v(" "),
                  _vm._m(1),
                  _vm._v(" "),
                  _c("div", { staticClass: "forget-password" }, [
                    _c("p", { staticClass: "m-0" }, [
                      _c(
                        "a",
                        {
                          staticStyle: { cursor: "pointer" },
                          on: {
                            click: function($event) {
                              return _vm.showForget()
                            }
                          }
                        },
                        [_vm._v("Forgot your password ?")]
                      )
                    ])
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.step === 2
              ? _c("form", [
                  _vm.display.error
                    ? _c(
                        "div",
                        {
                          staticClass: "alert alert-danger",
                          attrs: { role: "alert" }
                        },
                        [_vm._v(_vm._s(_vm.display.error))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("h5", { staticClass: "form-title" }, [
                    _vm._v("FORGOT YOUR PASSWORD ?")
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "Enter the email that is registered to your account below to reset your password."
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("div", { staticClass: "input-icon" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.username,
                            expression: "form.username"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|email",
                            expression: "'required|email'"
                          }
                        ],
                        ref: "email",
                        staticClass: "form-control",
                        attrs: {
                          type: "email",
                          name: "email",
                          placeholder: "Email"
                        },
                        domProps: { value: _vm.form.username },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.form, "username", $event.target.value)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _vm.errors.count() > 0
                      ? _c(
                          "span",
                          {
                            staticClass: "text-danger",
                            staticStyle: { "margin-top": "15px" }
                          },
                          [_vm._v("Please enter a valid email address.")]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-actions f-btn" }, [
                    _c(
                      "a",
                      {
                        staticClass: "white-btn float-left",
                        on: { click: _vm.hideForget }
                      },
                      [_vm._v("Go to Login ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "b-btn red-btn",
                        attrs: {
                          type: "button",
                          disabled:
                            _vm.errors.count() > 0 || _vm.waiting == true
                        },
                        on: {
                          click: function($event) {
                            return _vm.forgetAction()
                          }
                        }
                      },
                      [_vm._v("Submit\n              ")]
                    )
                  ]),
                  _vm._v(" "),
                  _vm.display.success
                    ? _c(
                        "h6",
                        {
                          staticStyle: {
                            "margin-top": "20px",
                            "font-weight": "bold"
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-check" }),
                          _vm._v(" " + _vm._s(_vm.display.success))
                        ]
                      )
                    : _vm._e()
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "copyright" }, [
            _vm._v("B1G1 © " + _vm._s(new Date().getFullYear()))
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo" }, [
      _c("a", { attrs: { href: "https://www.b1g1.com" } }, [
        _c("link", {
          attrs: {
            rel: "stylesheet",
            media: "all",
            type: "text/css",
            href: "/static/front/font_css.css"
          }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "logo-default",
          attrs: { src: "/static/logos/logo.png", alt: "alt" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "dont-sec" }, [
        _c("p", [
          _vm._v("Don't have an account?"),
          _c("br"),
          _c("a", { attrs: { href: "https://www.b1g1.com/businessforgood" } }, [
            _vm._v("Click here")
          ]),
          _vm._v(" to find out\n                  more about B1G1.")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ef68022e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef68022e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = null
// module chunks = 